module.exports = __webpack_public_path__ + "img/page5_blur.16a2238b.png";